import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {PLACEHOLDER_OPTIONS} from "../../placeholders.constants"

@Component({
  selector: 'app-email-sms-placeholder-modal',
  templateUrl: './email-sms-placeholder-modal.component.pug',
  styleUrls: ['./email-sms-placeholder-modal.component.scss'],
  standalone: false
})
export class EmailSmsPlaceholderModalComponent implements OnInit {
  @Input() variables: any;
  @Input() showSMS = true;
  placeholderText = $localize`Personalise your correspondence using placeholders to automatically insert text. Ensure the placeholders you use are written in exact format provided, paying attention to brackets and underscores.`;
  placeholders: any[] = [];
  required = $localize `Required`;
  optional = $localize `Optional`;

  public cancelClick: EventEmitter<any> = new EventEmitter<any>()

  get modalTitleText() { return this.showSMS ? $localize`Email and SMS text placeholders` : $localize`Email text placeholders` }

  constructor(public _bsModalRef: BsModalRef,
    private permission: PermissionsService) { }

  ngOnInit(): void {
    this.placeholderText = $localize`Personalise your correspondence using placeholders to automatically insert text. Ensure the placeholders you use are written in the exact format provided, paying attention to brackets and underscores.`;

    if(this.variables !== undefined) {
      this.variables.forEach((val, index) => {
        let placeholder = {};
        placeholder['name'] = val.name;
        placeholder['description'] = PLACEHOLDER_OPTIONS.get(val.name);
        placeholder['sms'] = val.sms_required === true ? this.required : this.optional;
        placeholder['email_body'] = val.email_body_required === true ? this.required : this.optional;
        placeholder['email_subject'] = val.email_subject_required === true ? this.required : this.optional;
        this.placeholders.push(placeholder);
      });
    }
  }

  cancel() {
    this._bsModalRef.hide();
    this.cancelClick.emit(true);
    this._bsModalRef.hide();
  }
}
